<template lang="pug">
  validation-observer(ref='validation' tag='form', v-if="processo.id")
    el-card(shadow='hover').card-collapse
      el-row.margin-medium-top(:gutter="20")
        el-col(:span='8').center
          app-display(label="Nome do Interessado:", :content="processo.nomeRazaoSocialInteressado")
          app-display(label="Número do processo:", :content="processo.numeroProcesso")
        el-col(:span='8')
          app-display(label="CPF do Interessado:", :content="processo.cpfCnpjInteressado")
          app-display(label="Tipo de Processo:", :content="processo.tipo.nome")
        app-opcoes-header-analise.right(
          :idProcesso="processo.id",
          :numeroProcesso="processo.numeroProcesso",
          :tipoProcesso="processo.tipo.codigo",
          :protocolo="processo.numeroProtocolo",
          :btnSolicitarInformacao="false",
          :btnRetificacao="false")
    template(
      v-if="step === 1"
    )
      el-steps.mt-20(:active='tela', finish-status='success', align-center, v-if="exibirSteps")
        el-step(
          title='Informar dados do documento',
          :status='tela > 0 ? "success" : "process"'
          icon="el-icon-edit-outline"
        )
        el-step(
          title='Confirmar dados'
          status="process"
          icon="el-icon-tickets"
        )
      div.alinhamento-dados
        div(v-if="tela === 0")
          validation-observer(ref='validation' tag='form')
            form(@submit.prevent="onSubmit" v-if="custasCertidao")
              div(v-for="(dadosCertidao, index) in custasCertidao")
                el-row(type="flex", :gutter="40")
                  app-display.numero-certidao(label="Certidão nº:", :content="dadosCertidao.numeroCertidao")
                el-row(type="flex", :gutter="40")
                  el-col
                    validation-provider(v-slot="{ errors }")
                      app-label(label="Quantidade de Folhas:")
                      el-input.input(
                        v-model='custasCertidao[index].quantidadeFolhas'
                        disabled
                      )
                      span.help.erro {{ errors[0] }}
                  el-col()
                    app-label(label="Quantidade de Módulos:")
                    el-input.input(
                      v-model='custasCertidao[index].quantidadeModulos'
                      @change="calcularCustas"
                    )
                  el-col()
                    validation-provider(rules="required", v-slot="{ errors }")
                      app-label(label="Ancianidade do Título :")
                      el-input.input(
                        v-model='custasCertidao[index].ancianidade'
                        :class="{'erro' : errors.length}"
                      )
                  el-col()
                    app-label(label="Valor da Certidão :")
                    app-double-input.input-valor(
                      :value='calculoValorCertidao(index)',
                      :disable='true',
                      prefix='R$ '
                    )
                app-divider.mb-20(label='')
              el-row(type="flex", :gutter="40")
                el-col()
                  app-label(label="Data de Vencimento:")
                  el-input.input(
                    :value='formatData(dataVencimento)',
                    prefix-icon='el-icon-date',
                    disabled
                  )
                el-col()
                  app-label(label="Receita:")
                  el-input.input(
                    v-model='receita'
                    disabled
                  )
                el-col()
                  app-label(label="Data do Cálculo:")
                  el-input.input(
                    :value='dataCalculo',
                    prefix-icon='el-icon-date',
                    disabled
                  )
                el-col()
                  app-label(label="Referência:")
                  el-input.input(
                    :value='referencia',
                    prefix-icon='el-icon-date',
                    disabled
                  )
                el-col()
                  app-label(label="Valor Total:")
                  app-double-input.input-valor(
                    :value='calculoTotalCustas()',
                    :disable='true',
                    prefix='R$ '
                  )
              app-divider.mb-20(label='')
              el-row.mb-20(type="flex", :gutter="40")
                el-col()
                  app-label(label="Nome/Razão Social:")
                  el-input.input(
                    :value='dadosInteressado.nomeRazaoSocial',
                    disabled
                  )
                el-col()
                  app-label(label="CPF/CNPJ:")
                  el-input.input(
                    :value='dadosInteressado.cpfCnpj',
                    disabled
                  )
                el-col()
                  app-label(label="Documento de Origem:")
                  el-input.input(
                    :value='processo.numeroProcesso',
                    disabled
                  )
              el-row.mb-20(type="flex", :gutter="40")
                el-col()
                  validation-provider(rules="required", v-slot="{ errors }")
                    app-label(label="Município:")
                    el-select.full-width.input(
                    v-model='idMunicipio'
                      :class="{'erro' : errors.length}"
                    )
                      el-option(
                        v-for='municipio in municipios'
                        :key='municipio.id',
                        :label='municipio.nome'
                        :value='municipio.id'
                      )
                    span.help.erro {{ errors[0] }}
                el-col()
                  validation-provider(rules="required", v-slot="{ errors }")
                    app-label(label="Endereço:")
                    el-input.input(
                      v-model='endereco',
                      :value='endereco',
                      :class="{'erro' : errors.length}"
                      maxlength="100"
                    )
                    span.help.erro {{ errors[0] }}
                el-col()
                  validation-provider(rules="required", v-slot="{ errors }")
                    app-label(label="Telefone:")
                    el-input.input(
                      v-model='telefone',
                      :value='telefone',
                      v-mask="['(##) #####-####', '(##) ####-####']",
                      :class="{'erro' : errors.length}"
                    )
                    span.help.erro {{ errors[0] }}
              el-row
                el-col
                  app-label(
                    label="Informações Adicionais: ",
                    :required='false'
                  )
                  el-input(
                    type='textarea',
                    :rows='5',
                    placeholder='Digite o texto...',
                    v-model='informacoesAdicionais',
                    maxlength='500',
                    show-word-limit
                  )
        div(v-if="tela === 1")
          el-divider
            h3 Dados do documento
          el-row.dados-documento(:gutter="40")
            el-col(:span="8")
              app-display(label="Nome/Razão Social:", :content="dadosInteressado.nomeRazaoSocial")
              app-display(label="CPF/CNPJ:", :content="dadosInteressado.cpfCnpj")
              app-display(label="Endereço:", :content="endereco")
              app-display(label="Município:", :content="municipio")
            el-col(:span="8")
              app-display(label="Telefone:", :content="telefone")
              app-display(label="Documento Origem:", :content="processo.numeroProcesso")
              app-display(label="Referência:", :content="receita")
            el-col(:span="8")
              app-display(label="Data de Vencimento:", :content="formatData(dataVencimento)")
              app-display(label="Data do Cálculo:", :content="dataCalculo")
              app-display(label="Valor Total:", :content="formatValor(calculoTotalCustas())")
              app-display(label="Informações Adicionais:", :content="informacoesAdicionais")
          el-divider
            h3 Dados das Certidões
          div.dados-certidoes(v-for="(dadosCertidao, index) in custasCertidao")
            el-row(:gutter="40")
              el-col(:span="6")
                app-display(label="Certidão nº:", :content="dadosCertidao.numeroCertidao")
              el-col(:span="6")
                app-display(label="Quantidade de Folhas:", :content="dadosCertidao.quantidadeFolhas")
              el-col(:span="6")
                app-display(label="Quantidade de Módulos:", :content="dadosCertidao.quantidadeModulos")
              el-col(:span="6")
                app-display(label="Ancianidade do Título:", :content="dadosCertidao.ancianidade")
            el-row(:gutter="40")
              el-col(:span="6")
                app-display.dados-linha-valor-certidao(label="Valor Total da Certidão:", :content="formatValor(calculoValorCertidao(index))")
              el-col(:span="6")
                app-display(label="Valor das Folhas:", :content="formatValor(dadosCertidao.valorCalculoFolhas)")
              el-col(:span="6")
                app-display(label="Valor dos Módulos:", :content="formatValor(dadosCertidao.valorCalculoModulos)")
              el-col(:span="6")
                app-display(label="Valor da Ancianidade:", :content="formatValor(dadosCertidao.ancianidade * dadosCertidao.valorAncianidade)")
            el-divider
      app-buttons-cadastro(
        :isPrimeiroPasso='isPrimeiroPasso',
        :isUltimoPasso='tela === 1'
        @cancelar='cancelar',
        @proximo='proximo',
        @voltar='voltar',
        @finalizar='finaliza',
        :showButtonCancelar='exibirSteps',
        :showButtonProximo='exibirSteps',
      )
    template(
      v-if="step === 2 && dadosCadastro"
    )
      el-card(shadow="hover").card-collapse
        app-despachos(
          :idProcesso="idProcesso",
          :data="dadosCadastro.setores",
          @getDownload="getDownload",
          @getAnotacao="getAnotacao"
        )
</template>

<script>
import FileSaver from 'file-saver'
import AppLabel from '@/components/AppLabel'
import AppDivider from '@/components/AppDivider'
import AppDisplay from '@/components/AppDisplay'
import AppButtonsCadastro from '@/components/AppButtonsCadastro'
import AppDoubleInput from '@/components/AppDoubleInput'
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import AppOpcoesHeaderAnalise from './components//modal/AppOpcoesHeaderAnalise'
import AppPagamento from '@/components/AppPagamento'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppDespachos from '@/components/AppDespachos'
import axios from '@/utils/api'

export default {
  components: {
    AppLabel,
    AppDivider,
    AppDisplay,
    AppButtonsCadastro,
    AppDoubleInput,
    AppOpcoesHeaderAnalise,
    AppPagamento,
    AppDespachos
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      tela: 1,
      valorTotal: 0,
      dataEmissao: new Date(),
      municipio: null,
      pegarMunicipio: null,
      municipios: null,
      endereco: '',
      telefone: '',
      idMunicipio: null,
      informacoesAdicionais: '',
      dadosInteressado: null,
      custasCertidao: [],
      dadosCadastro: null,
      step: 1,
      processo: {
        numeroProcesso: null,
        numeroProtocolo: null
      },
      isEdicao: false,
      idBoletoEdicao: null,
      visualizarDae: false,
      isVisualizarMunicipio: false,
      options: {
        disabledDate (time) {
          return time.getTime() < Date.now()
        }
      }
    }
  },
  props: {
    idProcesso: {
      required: true
    }
  },
  async mounted () {
    this.dadosInteressado = await this.processoPessoa(this.idProcesso)
    const processo = await this.getProcessoById(this.idProcesso)
    this.processo = processo
    this.custasCertidao = await this.getInformacoesCustasCertidao(this.idProcesso)
    this.municipios = await this.findByCodigoEstado(process.env.ESTADO.toUpperCase()) || []
    this.isVisualizarMunicipio = !!this.municipios.find(m => m.id === this.dadosInteressado.endereco.municipio.id)
    this.tela1()
    if (this.isVisualizarMunicipio) {
      this.utilizarMunicipio()
      this.utilizarTelefone()
      this.utilizarEndereco()
    }
  },
  computed: {
    ...mapState({
      ORGAO: state => state.userInterface.dadosEstado.ORGAO
    }),
    isEstadoMA () {
      return process.env.ESTADO === 'ma'
    },
    exibirSteps () {
      return true
    },
    dataCalculo () {
      return moment(new Date()).format('DD/MM/YYYY')
    },
    referencia () {
      return moment(new Date()).format('MM/YYYY')
    },
    isPrimeiroPasso () {
      if (this.tela === 0) {
        return true
      }
      return false
    },
    receita () {
      return `CUSTAS PROCESSUAIS/${this.ORGAO} 5802-5`
    },
    dataVencimento () {
      return moment(new Date().getTime() + 3600 * 1000 * 24 * 30).format('YYYY-MM-DD')
    }
  },

  methods: {
    ...mapActions({
      getProcessoById: 'processo/getProcessoById',
      getInformacoesCustasCertidao: 'processo/getInformacoesCustasCertidao',
      finalizar: 'analiseDae/finalisar',
      getBoletosByProcesso: 'dae/getBoletosByProcesso',
      findByCodigoEstado: 'dae/findByCodigoEstado',
      processoPessoa: 'dae/processoPessoa',
      iniciaAnalise: 'processo/iniciaAnalise',
      reemitirDae: 'dae/reemitirDae',
      updateDae: 'dae/updateDae',
      updateDadosCertidao: 'dae/updateDadosCertidao'
    }),
    async tela1 () {
      const processo = await this.getBoletosByProcesso(this.processo.numeroProcesso)

      if (processo.length > 0) {
        this.tela = 0
        this.visualizarDae = true
      }
    },
    async utilizarEndereco () {
      this.endereco = `${this.dadosInteressado.endereco.logradouro}, ${this.dadosInteressado.endereco.numero ? this.dadosInteressado.endereco.numero : 'sem número'}, ${this.dadosInteressado.endereco.complemento ? (this.dadosInteressado.endereco.complemento + ',') : ''} ${this.dadosInteressado.endereco.bairro}`
    },
    async utilizarTelefone () {
      this.telefone = this.dadosInteressado.telefones[0].numero
    },
    utilizarMunicipio () {
      this.idMunicipio = this.dadosInteressado.endereco.municipio.id
    },
    async checkValidacao () {
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Por favor, preencha os campos obrigatórios.')
        return false
      }
      return true
    },
    cancelar () {
      this.isEdicao = false
      this.$router.back()
    },
    async proximo () {
      if (this.tela === 0 && !await this.checkValidacao()) {
        return
      }
      this.tela++
    },
    voltar () {
      if (this.tela === 0) this.isEdicao = false
      this.tela--
    },
    formatValor (valor) {
      return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    formatData (data) {
      return moment(data).format('DD/MM/YYYY')
    },
    finaliza () {
      this.confirmBox(this.isEstadoMA ? this.$messages.CONFIRMAR_BOLETO.replace('DAE_BOLETO', 'Boleto') : this.$messages.CONFIRMAR_BOLETO,
        this.$messages.TITULO_WARNING,
        () => {
          const ref = moment(new Date()).format('YYYYMM')
          let boleto
          if (this.isEdicao) {
            boleto = {
              id: this.idBoletoEdicao,
              valorTotal: this.calculoTotalCustas()
            }
            this.updateDae(boleto).then(() => {
              this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
                this.isEstadoMA ? this.$messages.BOLETO_SUCCESS.replace('DAE', 'Boleto') : this.$messages.BOLETO_SUCCESS)
              this.$router.push({
                name: 'EMISSAO_CUSTAS_CERTIDAO'
              })
            }).catch((error) => {
              this.showNotificacao(
                this.$messages.TIPO_ERROR,
                this.$messages.TITULO_ERROR,
                error.message
              )
            })
          } else {
            boleto = {
              codigoMunicipio: this.idMunicipio,
              dataCalculo: this.dataCalculo,
              dataVencimento: this.dataVencimento,
              documentoOrigem: this.processo.numeroProcesso,
              enderecoSolicitante: this.endereco,
              identificacao: this.dadosInteressado.cpfCnpj,
              informacoesAdicionais: this.informacoesAdicionais,
              nomeSolicitante: this.dadosInteressado.nomeRazaoSocial,
              periodoReferencia: ref,
              telefoneSolicitante: this.telefone,
              valorTotal: this.calculoTotalCustas()
            }
            this.finalizar(boleto).then(() => {
              this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
                this.isEstadoMA ? this.$messages.BOLETO_SUCCESS.replace('DAE', 'Boleto') : this.$messages.BOLETO_SUCCESS)
              this.$router.push({
                name: 'EMISSAO_CUSTAS_CERTIDAO'
              })
            }).catch((error) => {
              this.showNotificacao(
                this.$messages.TIPO_ERROR,
                this.$messages.TITULO_ERROR,
                error.message
              )
            })
          }
        },
        () => {})
    },
    calculoValorCertidao (index) {
      return this.custasCertidao[index].valorCalculoModulos + this.custasCertidao[index].valorCalculoFolhas + (this.custasCertidao[index].ancianidade * this.custasCertidao[index].valorAncianidade)
    },
    calculoTotalCustas () {
      let valor = 0
      for (let index = 0; index < this.custasCertidao.length; index++) {
        valor = valor + this.calculoValorCertidao(index)
      }
      return valor
    },
    async getDownload (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    },
    async calcularCustas () {
      this.custasCertidao = await this.updateDadosCertidao(this.custasCertidao)
    }
  }
}
</script>

<style scoped lang="scss">
.card-collapse {
  border-radius: 10px;
  margin: 10px 0;
}

.margin-medium-top {
  margin-top: 20px;
}

.right {
  float: right;
}

.small-margin-top {
  margin-top: 10px;
}

.flex {
  display: flex;
}

.margin-btn {
  width: 16px;
  height: 25px;
  margin-bottom: 20px;
}

.justify {
  justify-content: space-between;
}

.btn {
  padding: 8px;
  margin-top: 1vh;
}

.disabled {
  background-color: #f5f7fa;
  color: #c8c5d3;
  cursor: not-allowed;
}

.full-width {
  width: -webkit-fill-available;
}

.mt-20 {
  margin-top: 20px;
}

.mb-20 {
  margin-bottom: 20px;
}

.mb-40 {
  margin-bottom: 40px;
}
.el-input__prefix {
  margin-top: 12px;
}

.link {
  cursor: pointer;
  color: #009f61;
  font-size: 12px;
  &:hover {
    font-weight: bold;
  }
}

.card-container {
  margin: 20px;
  border-radius: 10px;
}

.titulo-analise {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-bottom: solid 1px #e6e6e6;
}

>>> .el-table__row {
  &:last-child {
    font-weight: bold;
  }
}

.alinhamento-dados{
  margin-top: 20px;
}

.numero-certidao{
  padding-left: 20px;
}

.dados-documento{
  padding-top: 30px;
  padding-bottom: 20px;
}

.dados-certidoes{
  padding-top: 30px;
}

.input-valor{
  border-radius: 20px;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/GerarCustasCertidao.vue